// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__W31Ii","loader":"Preloader_loader__BYY7v","spin":"Preloader_spin__Lhzih"};